import { createAsyncThunk } from '@reduxjs/toolkit';
import { _discountUrls } from '@custom/Utils/constants/apiUrls';

const getDiscountRequestsApi = createAsyncThunk('getDiscountRequestsApi', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    let url = _discountUrls.getRequests;
    const query = new URLSearchParams();
      if (hospitalId) query.append('hospitalId', hospitalId);
      query.append('page', '1');
      query.append('limit', '50');

    let response = await fetch(`${url}?${query}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch package details');
    }

    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getDiscountRequestsApi;
